/**
 * ContextVariable domain model
 */
export class ContextVariable {
  constructor(data = {}) {
    this.id = data.id || null;
    this.title = data.title || '';
    this.context = data.context || '';
    this.userId = data.userId || null;
    this.organizationId = data.organizationId || null;
    this.isGlobal = data.isGlobal === true || data.isGlobal === 1 || data.isGlobal === '1';
    this.createdAt = data.createdAt || new Date().toISOString();
    this.updatedAt = data.updatedAt || new Date().toISOString();
  }

  /**
   * Create a ContextVariable instance from data
   */
  static fromData(data) {
    return new ContextVariable(data);
  }

  /**
   * Convert to plain object
   */
  toJSON() {
    return {
      id: this.id,
      title: this.title,
      context: this.context,
      userId: this.userId,
      organizationId: this.organizationId,
      isGlobal: this.isGlobal,
      createdAt: this.createdAt,
      updatedAt: this.updatedAt,
    };
  }
}

